import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ClientPage from "../pages/ClientPage.jsx";
import PlanPage from "../pages/PlanPage.jsx";
import SchedulePage from "../pages/SchedulePage.jsx";
import ResourcePage from "../pages/ResourcePage.jsx";
import TaskPage from "../pages/TaskPage.jsx";
import {
  AdminViewRoutes,
  DEFAULT_ROUTE,
  DynamicParamKey,
  VIEW_TYPES
} from "../../other/constants/OtherKeys.jsx";
import AlertPage from "../pages/AlertPage.jsx";
import ChecklistPage from "../pages/ChecklistPage.jsx";
import UserPage from "../pages/UserPage.jsx";
import ContactPage from "../pages/ContactPage.jsx";
import TaskBudgetPage from "../pages/TaskBudgetPage.jsx";
import RemindersPage from "../pages/RemindersPage.jsx";
import MySwivuPage from "../pages/MySwivuPage.jsx";
import IncentivePointsPage from "../pages/IncentivePointsPage.jsx";
import SettingsPage from "../pages/SettingsPage";
import CoveragePage from "../pages/CoveragePage";
import WorkFilesPage from "../pages/WorkFilesPage";

const AdminMainRoutes = () => {
  return (
    <Switch>
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.resources]}
        component={ResourcePage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.tasks]}
        component={TaskPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.planView]}
        component={PlanPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.schedulerView]}
        component={SchedulePage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.clients]}
        component={ClientPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.notify]}
        component={AlertPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.users]}
        component={UserPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.checklists]}
        component={ChecklistPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.contacts]}
        component={ContactPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.reminder]}
        component={RemindersPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.taskBudget]}
        component={TaskBudgetPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.mySwivu]}
        component={MySwivuPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.incentivePoints]}
        component={IncentivePointsPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.settings]}
        component={SettingsPage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.coverage]}
        component={CoveragePage}
      />
      <Route
        exact
        path={AdminViewRoutes[VIEW_TYPES.workFiles]}
        component={WorkFilesPage}
      />
      <Redirect
        from={`/:${DynamicParamKey}`}
        to={{ pathname: DEFAULT_ROUTE, search: window.location.search }}
      />
    </Switch>
  );
};

export default AdminMainRoutes;
